export default function colorTheme(name, text = false) {
  if (name === 'PILOTE') {
    return 'indigo';
  }

  if (name === 'EXPERT') {
    return 'pink';
  }

  return text ? 'back' : 'gray';
}